import * as React from 'react'
import { BPMChart } from '../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../api'
import { ArgumentAxis, Label, TickInterval, SeriesTemplate, CommonSeriesSettings, Legend, Series } from 'devextreme-react/chart'
import { GroupByDate, GroupByDateType } from '../../../components/GroupByDate'
import { resultDateTransformer } from '../../../utils/date'
import { sp } from '../../../utils/platformSelect'
import { PlatformContext } from '../../../components/context/platform'

export const DownloadChart: React.FunctionComponent<{ album: string }> = ({ album, ...props }) => {
    const platform = React.useContext(PlatformContext)
    const [groupDateBy, setGroupDateBy] = React.useState<GroupByDateType>('day')

    const toolbarItems = GroupByDate(groupDateBy, (selected) => {
        setGroupDateBy(selected)
    })
    return (
        <BPMChart {...props} title='Downloads' subTitle={sp(platform, { default: 'By Version', create: undefined })} type='bar'
            additionalParams={{ groupDateBy, album }}
            onRequestLoad={(options, signal) => {
                return resultDateTransformer(BPMAnalyticsAPI.get<any>('album/downloads', options, signal))
            }} toolBarItems={() => toolbarItems}>
            {platform != 'create' && <SeriesTemplate
                nameField={'tag_name'}
            />}
            {platform == 'create' && <Series name='Downloads' />}
            <CommonSeriesSettings type='bar'
                valueField="count"
                argumentField="date">
            </CommonSeriesSettings>
            <ArgumentAxis>
                <Label format={groupDateBy == 'month' ? 'month' : "shortDate"} />
                <TickInterval days={groupDateBy == 'day' ? 1 : undefined}
                    weeks={groupDateBy == 'week' ? 1 : undefined}
                    months={groupDateBy == 'month' ? 1 : undefined} />
            </ArgumentAxis>

            <Legend visible />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Album/charts/DownloadChart.tsx